import type { CSSObject } from 'tss-react'

// v4 `makeStyles(..., { index: 1 })` injected the sheet after every other one, so its rules won
// equal-specificity ties (e.g. over Typography's own classes). tss-react has no sheet index;
// doubling the class selector gives these rules the same precedence.
const withV4IndexPriority = <T extends Record<string, CSSObject>>(rules: T): T =>
  Object.fromEntries(
    Object.entries(rules).map(([name, rule]) => [name, { '&&': rule }])
  ) as unknown as T

export default withV4IndexPriority
